module.exports = __webpack_public_path__ + "img/hybrid_energy_resets.5844a057.jpg";